/**
 * Reminder Feature Routes
 */

import type { RouteRecordRaw } from 'vue-router';

export const reminderRoutes: RouteRecordRaw[] = [
  {
    path: '/reminder',
    name: 'ReminderDashboard',
    component: () => import('./views/ReminderDashboard.vue'),
    meta: {
      title: 'reminder.dashboard.title',
      requiresAuth: true,
      layout: 'default',
    },
  },
  {
    path: '/reminder/reminder-settings',
    name: 'ReminderSettings',
    component: () => import('./views/ReminderSettings.vue'),
    meta: {
      title: 'reminder.reminderSettings.title',
      requiresAuth: true,
      layout: 'default',
    },
  },
  {
    path: '/reminder/settings-list',
    name: 'ReminderSettingsList',
    component: () => import('./views/SettingsList.vue'),
    meta: {
      title: 'reminder.settingsList.title',
      requiresAuth: true,
      layout: 'default',
    },
  },
  {
    path: '/reminder/email-template',
    name: 'ReminderEmailTemplate',
    component: () => import('./views/EmailTemplate.vue'),
    meta: {
      title: 'reminder.emailTemplate.title',
      requiresAuth: true,
      layout: 'default',
    },
  },
  {
    path: '/reminder/email-settings',
    name: 'ReminderEmailSettings',
    component: () => import('./views/EmailSettings.vue'),
    meta: {
      title: 'reminder.emailSettings.title',
      requiresAuth: true,
      layout: 'default',
    },
  },
];

export default reminderRoutes;

